// Tablet breakpoint — aligns with @fiverr-private/theme numericBreakpoints.md.
// Used as both the gsap.matchMedia boundary and the scale floor anchor.

import { numericBreakpoints } from '@fiverr-private/theme/src/shared/themeVars';

export const TABLET = { width: numericBreakpoints.md } as const;

export const MOBILE = {
    type: {
        heading: {
            // 45px @360 (Figma), scaled proportionally (12.5vw) so the 2-line wrap holds as it grows.
            fontSize: 'clamp(45px, 12.5vw, 96px)',
            letterSpacing: '-0.06em', // -2.7px @45px; em keeps tracking proportional as the size grows
            lineHeight: '1.02', // Figma tight leading (was the default 1.3 — too much gap between lines)
            textTransform: 'uppercase',
        },
        body: {
            letterSpacing: 'clamp(-0.34px, -0.02vw - 0.18px, -0.26px)',
            lineHeight: '1.3',
        },
    },
} as const;

// Figma artboard size — the whole composition is laid out in this fixed coordinate
// space, then scaled to fit smaller viewports so nothing gets clipped.
export const DESIGN = {
    width: 1440,
    height: 988,
} as const;

// Image slot dimensions (Figma: left 680 / top 509 / 600×400 / radius 25)
export const SLOT = {
    left: 680,
    top: 509,
    width: 600,
    height: 400,
    borderRadius: 25,
} as const;

// Animation timing (scrubbed timeline units = arbitrary scroll units)
export const ANIM = {
    hold: 0.5, // scroll budget before first card's image scroll
    imageScroll: 1, // duration of within-card film-slide (image[0] out, image[1] in)
    cardScroll: 1.5, // duration of the whole-card scroll-up to the next card
    outgoingRise: 800, // px the outgoing image drifts up while shrinking
    outgoingScale: 0.7, // outgoing image scales 1 -> 0.7
    incomingScale: 1.15, // incoming image starts a bit bigger, settles to 1 as it rises into the slot
} as const;
